import { type SegmentedControlItem } from '@mantine/core';
import { type ProcessingMode } from '~/entities/processing-mode';

export const processingModes: SegmentedControlItem[] = [
    { label: 'Выплаты', value: 'payout' satisfies ProcessingMode },
    { label: 'Прием', value: 'payin' satisfies ProcessingMode },
];
